import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-cardSolutionSlider';
	$(base, context).each(function(i, el){
		var slides = $(el).find('.b-cardSolution');
		var wrapper = $(el).find(base + '-wrapper');

		function setWrapperStyles(swiper) {
			var wrapperCenterClass = 'b-cardSolutionSlider-wrapper_center';
			var buttonDisabledClass = swiper.params.navigation.disabledClass;

			if ($(swiper.params.navigation.prevEl).hasClass(buttonDisabledClass) && $(swiper.params.navigation.nextEl).hasClass(buttonDisabledClass)) {
				wrapper.addClass(wrapperCenterClass);
			} else {
				wrapper.removeClass(wrapperCenterClass);
			}
		}

		function setCenerSlides(swiper) {
			setTimeout(function() {
				setWrapperStyles(swiper)
			});
		}

		setTimeout(function() {
			var slider = new Swiper (el.querySelector('.b-cardSolutionSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 3,
				slideClass: 'b-cardSolution',
				loop: true,
				watchOverflow: true,
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					1024: {
						slidesPerView: 3,
						loop: slides.length > 3 ? true : false,
					},
					1250: {
						slidesPerView: 4,
						loop: slides.length > 4 ? true : false,
					},
					1680: {
						slidesPerView: 5,
						loop: slides.length > 5 ? true : false,
					},
				},
				on: {
					init: function() {
						setCenerSlides(this);
					},
					beforeResize: function() {
						setCenerSlides(this);
					},
					update: function() {
						setCenerSlides(this);
					},
				},
			});

			$(el).on('update', function() {
				slider.update();
			});
		});
	});
});
